var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 22.5V17.5C42.5 16.1739 41.9732 14.9021 41.0355 13.9645C40.0979 13.0268 38.8261 12.5 37.5 12.5H12.5C11.1739 12.5 9.90215 13.0268 8.96447 13.9645C8.02678 14.9021 7.5 16.1739 7.5 17.5V32.5C7.5 33.8261 8.02678 35.0979 8.96447 36.0355C9.90215 36.9732 11.1739 37.5 12.5 37.5H17.5M17.5 27.5C17.5 26.1739 18.0268 24.9021 18.9645 23.9645C19.9021 23.0268 21.1739 22.5 22.5 22.5H47.5C48.8261 22.5 50.0979 23.0268 51.0355 23.9645C51.9732 24.9021 52.5 26.1739 52.5 27.5V42.5C52.5 43.8261 51.9732 45.0979 51.0355 46.0355C50.0979 46.9732 48.8261 47.5 47.5 47.5H22.5C21.1739 47.5 19.9021 46.9732 18.9645 46.0355C18.0268 45.0979 17.5 43.8261 17.5 42.5V27.5ZM30 35C30 36.3261 30.5268 37.5979 31.4645 38.5355C32.4021 39.4732 33.6739 40 35 40C36.3261 40 37.5979 39.4732 38.5355 38.5355C39.4732 37.5979 40 36.3261 40 35C40 33.6739 39.4732 32.4021 38.5355 31.4645C37.5979 30.5268 36.3261 30 35 30C33.6739 30 32.4021 30.5268 31.4645 31.4645C30.5268 32.4021 30 33.6739 30 35Z",
    stroke: "#1E3F76",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.f1f89a71fd9d14978b0f6ba3ce1bcf7a.svg";
export { ForwardRef as ReactComponent };